<script lang="ts" setup>
import flagIcon from "~/assets/img/icon/flag.svg";
import {useAuthStore} from "#modules/auth/store/auth";
import {AppButton, AppTypography} from "~/components/base";
import AddAccount from "~/assets/img/icon/add-account.svg";
import {ReportForm} from '../../modules/report/components';

const {hasLoggedInUser} = useAuthStore();
const {jobId = 0} = defineProps<{
  jobId: number,
}>()
</script>

<template>
  <v-dialog max-width="536">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn
          v-bind="activatorProps"
          variant="plain"
          class="mt-6 report-btn d-flex w-auto align-content-center mb-16"
      >
        <img :src="flagIcon" alt="Flag" width="24" height="24" class="mr-2"/>
        <span class="report-btn-text">Report Listing</span>
      </v-btn>
    </template>

    <template v-slot:default="{ isActive }">
      <div class="d-flex flex-column dialog-card pa-4 pa-sm-8 overflow-y-auto" v-if="hasLoggedInUser">
        <div class="d-flex justify-space-between align-center">
          <AppTypography element="h5" type="title-5" class="w-auto flex-grow-1">Report this Listing</AppTypography>

          <AppButton
              class="border-thin flex-shrink-0"
              size="small"
              rounded="xl"
              variant="text"
              color="gray"
              icon="mdi mdi-close"
              type="button"
              @click="isActive.value = false"
          />
        </div>

        <div class="mt-4 mb-4 mb-sm-6">
          <ReportForm
              :report-id="jobId"
              submit-button-text="Submit Report"
              :cancel-button="false"
              report-type="job_posts"
              form-only
              @successful-submit-action="isActive.value = false"/>
        </div>
      </div>

      <div class="d-flex flex-column dialog-card text-center pa-4 pa-sm-6" v-if="!hasLoggedInUser">
        <div class="d-flex justify-end">
          <AppButton
              class="border-thin"
              size="small"
              rounded="xl"
              variant="text"
              color="gray"
              icon="mdi mdi-close"
              type="button"
              @click="isActive.value = false"
          />
        </div>

        <img :src="AddAccount" alt="Add Account" height="56" class="mt-2"/>

        <AppTypography element="h4" type="title-4" class="mt-6">Create an Account</AppTypography>
        <AppTypography element="p" type="body-1" class="mt-2 mb-6 px-2 px-sm-0">To continue, you'll need to create a free account, it
          only takes a minute.
        </AppTypography>

        <div class="d-flex flex-column flex-sm-row ga-3 ga-sm-4 pb-4 pb-sm-6">
          <div class="flex w-100">
            <AppButton
                color="yellow-darken-1"
                variant="flat"
                block
                @click="navigateTo('/register')"
            >
              Sign Up
            </AppButton>
          </div>
          <div class="flex w-100">
            <AppButton
                color=""
                variant="outlined"
                block
                @click="navigateTo('/login')"
            >
              Login
            </AppButton>
          </div>
        </div>
      </div>
    </template>
  </v-dialog>
</template>

<style scoped lang="scss">
:deep(.v-dialog) {
  margin: 16px;
  max-width: calc(100vw - 32px) !important;

  @media (min-width: 600px) {
    margin: 24px;
    max-width: 536px !important;
  }
}

.dialog-card {
  width: 100%;
  max-width: 100%;

  @media (min-width: 600px) {
    width: 536px;
  }
}

.report-btn {
  min-height: 40px !important;

  &-text {
    font-size: 0.875rem;

    @media (min-width: 600px) {
      font-size: 1rem;
    }
  }

  img {
    width: 20px;
    height: 20px;

    @media (min-width: 600px) {
      width: 24px;
      height: 24px;
    }
  }
}

:deep(.v-btn) {
  text-transform: none;
  letter-spacing: normal;
}
</style>